import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { OnboardingRegistrationSummary } from '@/common/models';
import { PaginationHelper, RegistrationsHelper } from '@/common/helpers';
import { Pagination } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Pagination,
  },
})
export default class RegistrationsList extends Vue {
  readonly pageSizeOptions: string[] = ['50', '100', '200'];

  @Prop({ required: true }) onboardingRegistrations!: OnboardingRegistrationSummary[];
  @Prop({ required: true }) currentPage!: number;

  pageSize: number = 50;

  RegistrationsHelper: typeof RegistrationsHelper = RegistrationsHelper;

  headers = [
    { text: 'Email', value: 'email' },
    { text: 'Name', value: 'name' },
    { text: 'Phone', value: 'phone' },
    { text: 'Status', value: 'status' },
    { text: 'Date created', value: 'createdAtUtc' },
    { text: 'Date updated', value: 'modifiedAtUtc' },
  ];

  get items(): any {
    return this.onboardingRegistrations ? this.onboardingRegistrations.map((onboardingRegistrationSummary: OnboardingRegistrationSummary) => ({
      ...onboardingRegistrationSummary,
      status: RegistrationsHelper.formatStatus(onboardingRegistrationSummary.status),
    })) : [];
  }

  get pages(): number {
    return PaginationHelper.pages(this.items, this.pageSize);
  }

  get showPagination(): boolean {
    return PaginationHelper.showPagination(this.items, this.pageSizeOptions);
  }

  get canPrevious(): boolean {
    return PaginationHelper.canPrevious(this.currentPage);
  }

  get canNext(): boolean {
    return PaginationHelper.canNext(this.currentPage, this.pages);
  }

  pageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
  }

  @Emit()
  pageChange(pageNumber: number) {
    this.$emit('pageChange', pageNumber);
  }

  @Emit()
  registrationClicked(item: OnboardingRegistrationSummary): void {
    this.$emit('registrationClicked', item.registrationId);
  }

}
